import PropTypes from "prop-types";
import React, { useEffect, useState, useContext } from "react";
import Logo from "../../components/header/Logo";
import NavMenu from "../../components/header/NavMenu";
import StoryMenu from "../../components/header/PortoMenu";
import IconGroup from "../../components/header/IconGroup";
import MobileMenu from "../../components/header/MobileMenu";
import HeaderTop from "../../components/header/HeaderTop";
import StaticContent from "../../context/ContentContext";

const HeaderOne = ({
  layout,
  top,
  borderStyle,
  headerPaddingClass,
  headerPositionClass,
  headerBgClass
}) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);
  const menuJson = useContext(StaticContent);

  const footerData = menuJson && menuJson?.content?.contentManagement?.data?.content?.items[0]?.footer

  useEffect(() => {
    const header = document.querySelector(".sticky-bar");
    // setHeaderTop(header.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  return (
    <div>
    <header
      className={`header-area clearfix ${headerBgClass ? headerBgClass : ""} ${
        headerPositionClass ? headerPositionClass : ""
      }`}
    >
      {/* <div
        className={`${headerPaddingClass ? headerPaddingClass : ""} ${
          top === "visible" ? "d-none d-lg-block" : "d-none"
        } header-top-area ${
          borderStyle === "fluid-border" ? "border-none" : ""
        }`}
      >
        <div className={layout === "container-fluid" ? layout : "container"}>
          <HeaderTop borderStyle={borderStyle} />
        </div>
      </div> */}

      <div
        className={` ${
          headerPaddingClass ? headerPaddingClass : ""
        } header-res-padding clearfix`}
      >
        <div className="container" style={{ height: '100px' }}>
          <div className="row">
            <div className="col-xl-2 col-lg-2   col-md-6 col-4">
              {/* header logo */}
              <Logo hidden imageUrl={footerData?.footerCopyrightSection?.footerLogo} logoClass="logo" />
            </div>
            <div className="col-xl-8 col-lg-8 d-none d-lg-block" style={{ paddingRight: '25px', height: '90px' }}>
              {/* Nav menu */}
              <NavMenu />
            </div>
            <div className="col-xl-2 col-lg-2 col-md-6 col-8">
              {/* Icon group */}
              <IconGroup />
              {/* <div><p style={{textAlign: 'end', margin: '5px'}}><b style={{border: '1px solid', padding: '3px'}}>My Balance: $ 500</b></p></div> */}
            </div>
            <div className="col-xl-12 col-lg-12 d-none d-lg-block">
              {/* Nav menu */}
            </div>
          </div>
        </div>
        {/* mobile menu */}
        <MobileMenu />
      </div>
    </header>
    <StoryMenu />
    </div>
  );
};

HeaderOne.propTypes = {
  borderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  layout: PropTypes.string,
  top: PropTypes.string
};

export default HeaderOne;
